module.exports = __webpack_public_path__ + "img/vi_vn.fbcb5fe6.svg";